<template>
  <div id="detail-flow">
    <pub-animate enterClass="zoomIn" @showAnimate="show">
      <div class="open-platform-header-text">
        <h1>{{ lanInfo.title[1] }}</h1>
      </div>
    </pub-animate>
    <div class="content-block content-width">
      <div class="content-item" v-for="(item,index) of lanInfo.flowName[id]" v-bind:key="index">
        <img :src="require(`../../assets/images/openPlatform/detail-flow${Number(id) + 1}-${index + 1}.png`)">
        <h3>{{ item }}</h3>
        <p v-html="lanInfo.flowContent[id][index]" v-if="lanInfo.flowContent[id]"></p>
        <span class="icon-right"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "openPlatformDetailFlow",
  props: ['id'],
  methods: {
    show() {
      setTimeout(() => {
        this.showPic1 = true;
      }, 800);
    },
  },
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.openPlatform;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
}
</script>

<style scoped lang="scss">
.content-width {
  width: 1200px;
  margin: 0 auto;
}

#detail-flow {
  background: #fff;
  padding-bottom: 46px;

  .open-platform-header-text {
    text-align: center;
    padding-top: 40px;

    h1 {
      color: #000000;
      font-size: 26px;
    }
  }

  .content-block {
    display: flex;
    margin-top: 20px;
    padding-top: 40px;

    .content-item {
      font-size: 16px;
      line-height: 24px;
      color: #787878;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      text-align: center;
      padding-bottom: 40px;
      position: relative;

      img {
        width: 60px;
        height: 60px;
        margin-bottom: 20px;
      }

      h3 {
        color: #000000;
        font-size: 18px;
        font-weight: bolder;
        margin-bottom: 12px;
      }

      p {
        width: 184px;
        margin: 0 auto;
        font-size: 16px;
      }

      .icon-right {
        background: url("../../assets/images/openPlatform/icon-right.png") no-repeat;
        background-size: cover;
        width: 14px;
        height: 26px;
        position: absolute;
        right: -7px;
        top: 30px;
      }

      &:last-child {
        .icon-right {
          display: none;
        }
      }

      &:hover {
        color: #1677FF;

        h3 {
          color: #1677FF;
        }
      }
    }

    .link {
      width: 104px;
      height: 44px;
      background: #0176D9;
      font-size: 16px;
      color: #FFFFFF;
      position: absolute;
      right: 20px;
      bottom: 40px;
      cursor: pointer;
    }
  }
}

</style>